var chunkMapping = {
	"8": [
		55008
	],
	"141": [
		33141
	],
	"252": [
		88252
	],
	"267": [
		18648
	],
	"358": [
		9358
	],
	"543": [
		81543
	],
	"634": [
		35634
	],
	"707": [
		26707
	],
	"801": [
		67801
	],
	"846": [
		43846
	],
	"907": [
		19907
	]
};
var idToExternalAndNameMapping = {
	"9358": [
		"default",
		"./HTMLBookLayout",
		20715
	],
	"18648": [
		"default",
		"./ViewParadidacticBooks",
		41466
	],
	"19907": [
		"default",
		"./Layout",
		62096
	],
	"26707": [
		"default",
		"./ContentSender",
		72902
	],
	"33141": [
		"default",
		"./ViewBooks",
		41466
	],
	"35634": [
		"default",
		"./BookPDF",
		40079
	],
	"43846": [
		"default",
		"./ParadidacticPDF",
		40079
	],
	"55008": [
		"default",
		"./ViewContents",
		72902
	],
	"67801": [
		"default",
		"./Subheader",
		84326
	],
	"81543": [
		"default",
		"./ViewSummary",
		41466
	],
	"88252": [
		"default",
		"./PedagogicalAssistantProvider",
		39546
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}